/**
 * Normalizes a base unit string for GraphQL `BaseUnit` (same names as backend).
 * Accepts legacy UI values `LITER` → `L`, `METER` → `M` for older stored data.
 */
export function toGraphQLBaseUnit(
  unit: string | undefined | null
): string | undefined {
  if (unit == null) return undefined;
  const u = String(unit).trim().toUpperCase();
  if (u === "") return undefined;
  if (u === "LITER") return "L";
  if (u === "METER") return "M";
  return u;
}
